module.exports = __webpack_public_path__ + "static/media/1.6478f5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/1.svg
// module id = 913
// module chunks = 0